import { MouseEventHandler, ReactNode } from 'react';

import { TriggerContainer } from './Dropdown.styled';

type Props = {
  onTriggerClick?: MouseEventHandler;
  qaId?: string;
  ariaLabel?: string;
  title: ReactNode;
  noPadding?: boolean;
};

export function Trigger({
  onTriggerClick,
  qaId,
  ariaLabel,
  title,
  noPadding,
}: Props) {
  return (
    <TriggerContainer
      onClick={onTriggerClick}
      data-qa-id={qaId ? `${qaId}-toggle` : undefined}
      aria-label={ariaLabel}
      $noPadding={noPadding}
    >
      <div>{title}</div>
    </TriggerContainer>
  );
}
